import { graphql, useStaticQuery } from 'gatsby';

export const useBfcmCarouselsQuery = () => {
  const data = useStaticQuery(graphql`
    query BfcmCarouselsQuery {
      customer: defaultPage(
        postTypeBfcmCarousel: {audience: {eq: customer}}
        originalType: {eq: "WpBfcmCarousel"}
      ) {
        components {
          ...DefaultTemplateComponents
        }
      }
      partner: defaultPage(
        postTypeBfcmCarousel: {audience: {eq: partner}}
        originalType: {eq: "WpBfcmCarousel"}
      ) {
        components {
          ...DefaultTemplateComponents
        }
      }
      prospect: defaultPage(
        postTypeBfcmCarousel: {audience: {eq: prospect}}
        originalType: {eq: "WpBfcmCarousel"}
      ) {
        components {
          ...DefaultTemplateComponents
        }
      }
    }
  `);

  return {
    customer: data?.customer?.components || [],
    partner: data?.partner?.components || [],
    prospect: data?.prospect?.components || [],
  };
};
